import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/usr/src/app/layouts/default.vue").then(m => m.default || m)),
  "error-layout": defineAsyncComponent(() => import("/usr/src/app/layouts/errorLayout.vue").then(m => m.default || m)),
  minimal: defineAsyncComponent(() => import("/usr/src/app/layouts/minimal.vue").then(m => m.default || m)),
  ppc: defineAsyncComponent(() => import("/usr/src/app/layouts/ppc.vue").then(m => m.default || m)),
  ppc26: defineAsyncComponent(() => import("/usr/src/app/layouts/ppc26.vue").then(m => m.default || m))
}